import React, {useEffect, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import './PaywallModal.less';
import clsx from 'clsx';


function PaywallModal(props) {
  const { children, onAccept, onReject, isSchoolAdmin, ...modalProps } = props;

  let buttons;

  if (isSchoolAdmin) {
    buttons =             <div className="PaywallModal__actions">
      <a href="/my/school-admin/settings/" target="_parent" className={clsx("PaywallModal__action-switch btn btn-tertiary")}
         role="button" >
        Review school settings
      </a>
    </div>;
  }
  else {
    buttons = <div className="PaywallModal__actions">
      <a href={`/pricing/`} className="btn btn-premium PaywallModal__action-accept"
         onClick={onAccept}>
        Upgrade</a>
    </div>;
  }

  return (
    <div className="PaywallModal">
      <Modal {...modalProps}>
        <div className="PaywallModal__body">
          <div className="PaywallModal__container">
            <div>
              {children}
            </div>
            <div className="PaywallModal__button">
              {buttons}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

PaywallModal.propTypes = {
  /** Paywall content */
  children: PropTypes.node,
  /** Optional handler for when a user clicks the "Upgrade" button */
  onAccept: PropTypes.func,
  /** Optional handler for when a user clicks the "No, thanks" button */
  onReject: PropTypes.func,
  /** Is this user a school admin but NOT a teacher */
  isSchoolAdmin: PropTypes.bool
};
PaywallModal.defaultProps = {
  children: null,
  onAccept: function() {},
  onReject: function() {}
};

export default PaywallModal;
